<template>
  <div class="core">
    <div class="layui-layer-title" style="cursor: move;">{{title}}</div>
      <div class="layui-layer-content">
        <div class="layui-layer-wrap">
          <div class="form-collapse">
            <div class="info">
              <layui-form ref="serviceForm" :show-form="true"  :requestUniqueId="requestId">
                <template slot-scope="{scope}">
                  <div class="layui-form">
                      <template>
                        <layui-collapse>
                          <div class="layui-colla-item">
                            <h2 class="layui-colla-title">客户基本信息</h2>
                            <div class="layui-colla-content layui-show">
                              <div class="layui-form-item-one">
                                <div class="layui-form-item">
                                    <label class="layui-form-label"> <span class="x-red">*</span>客户编号：
                                    </label>
                                    <div class="layui-input-inline" style="width: 30%;">
                                      <input type="text" :disabled="isBrowserStatus" v-model="config.form.CLIENT_BH" autocomplete="off" class="layui-input layui-disabled"  name="CLIENT_BH"/>
                                    </div>
                                </div>

                                <div class="layui-form-item">
                                  <label class="layui-form-label"> <span class="x-red">*</span>客户名称：
                                  </label>
                                  <div class="layui-input-inline" style="width: 30%;">
                                    <input type="text" :disabled="isBrowserStatus" v-model="config.form.CLIENT_NAME" autocomplete="off" class="layui-input layui-disabled"  name="CLIENT_NAME"/>
                                  </div>
                                </div>

                                <div class="layui-form-item">
                                  <label class="layui-form-label">行业类型：
                                  </label>
                                  <div class="layui-input-inline" style="width: 30%;">
                                    <layui-select
                                      :enabled="!isBrowserStatus"
                                      name="INDUSTRY_TYPE"
                                      table-name="DB_DICTIONARY"
                                      text-field="DIC_NAME"
                                      value-field="DIC_CODE"
                                      :queryCondition="{'DIC_CATEGORY:0' : '公司客户行业类型', 'DIC_PCODE:3': '-1'}"
                                      :show-null-option="true"
                                      :enable-search="true"
                                      v-model="config.form.INDUSTRY_TYPE"
                                    ></layui-select>
                                  </div>
                                </div>

                                <div class="layui-form-item">
                                  <label class="layui-form-label">联系人姓名：
                                  </label>
                                  <div class="layui-input-inline" style="width: 30%;">
                                    <input type="text" :disabled="isBrowserStatus" v-model="config.form.PERSON_NAME" autocomplete="off" class="layui-input layui-disabled"  name="PERSON_NAME"/>
                                  </div>
                                </div>

                                <div class="layui-form-item">
                                  <label class="layui-form-label">联系人电话：
                                  </label>
                                  <div class="layui-input-inline" style="width: 30%;">
                                    <input type="text" :disabled="isBrowserStatus" v-model="config.form.PERSON_PHONE" autocomplete="off" class="layui-input layui-disabled"  name="PERSON_PHONE"/>
                                  </div>
                                </div>

                                <div class="layui-form-item">
                                  <label class="layui-form-label">所属地：
                                  </label>
                                  <div class="layui-input-inline" style="width: 30%;">
                                    <div class="layui-input-inline" style="width: 100%;">
                                      <region-select
                                        :enabled="!isBrowserStatus"
                                        ref="ssd"
                                        v-model="config.form.SSD"
                                      ></region-select>
                                    </div>
                                  </div>
                                </div>

                                <div class="layui-form-item">
                                  <label class="layui-form-label">地址：
                                  </label>
                                  <div class="layui-input-inline" style="width: 30%;">
                                    <input type="text" :disabled="isBrowserStatus" v-model="config.form.ADDRESS" autocomplete="off" class="layui-input layui-disabled"  name="ADDRESS"/>
                                  </div>
                                </div>

                                <div class="layui-form-item">
                                  <label class="layui-form-label">备注：
                                  </label>
                                  <div class="layui-input-inline" style="width: 30%;">
                                    <input type="text" :disabled="isBrowserStatus" v-model="config.form.BZ" autocomplete="off" class="layui-input layui-disabled"  name="BZ"/>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </layui-collapse>
                      </template>
                  </div>
                  <div class="layui-form-btn">
                    <div class="layui-footer">
                      <button class="layui-btn refresh" title="关闭" @click="cancelOnClick()">
                        关 闭
                      </button>
                    </div>
                  </div>
                </template>
              </layui-form>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      config: {
        form: {}
      },
      formData: {},
      formType: '',
      title:'',
      isBrowserStatus: false
    }
  },
  mounted () {
    if(this.tabParam) {
      this.formData = this.tabParam.editRow;
      this.tableObj = this.tabParam.tableObj;
      this.formType = this.tabParam.formType;
      this.title = this.tabParam.title;

      if(!Array.isArray(this.formData.SSD)){
        this.formData.SSD = this.formData.SSD.split(',')
      }
      this.config.form = this.formData;
      this.isBrowserStatus = true
    }
  },
  methods: {
    cancelOnClick() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
      this.baseComponent.loadComponentByName('client');
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/person/clientManage/clientBrowserForm.vue